import styled from "styled-components";
import {
  ACCENT_PRIMARY_LIGHTEST,
  BRAND,
  GRAY,
  GRAY_LIGHTEST,
  WHITE
} from "@streeteasy/design-system/colors";
import Button from "@streeteasy/design-system/deprecated/Button";

const TourLikesWrapper = styled.div`
  background-color: ${GRAY_LIGHTEST};
  margin: 10px 0;
  max-width: 500px;
  padding: 15px 15px 0;
`;

const TourLikesGroup = styled.div`
  > p {
    margin-bottom: 8px;
  }
`;

const ModalHeaderButton = styled(Button).attrs({
  theme: "hollow",
  minWidth: true
})`
  color: ${WHITE};
  position: fixed;
  right: 15px;
`;

const Pill = styled.button`
  align-items: center;
  background-color: inherit;
  border: 1px solid ${GRAY};
  border-radius: 14px;
  box-sizing: border-box;
  color: ${BRAND};
  display: flex;
  font-family: "Source Sans Pro", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: bold;
  height: 30px;
  line-height: 18px;
  margin-bottom: 16px;
  max-width: fit-content;
  padding: 3px 14px;
  text-transform: uppercase;
  i {
    padding: 0 5px 0 0;
  }
  span {
    line-height: 17px;
  }
  &:hover {
    border: 1px solid #b2b2b2;
    cursor: pointer;
  }
`;

const LikesPill = styled(Pill)`
  background-color: ${ACCENT_PRIMARY_LIGHTEST};
  border: none;
  color: inherit;
  font-weight: 400;
  margin: 0 10px 8px 0;
  position: relative;
  text-transform: none;
  &:hover {
    background-color: #9cceff;
    cursor: default;
    border: none;
  }
  div {
    align-items: center;
    display: flex;
    height: 100%;
  }
  > div {
    margin-right: 22px;
  }
`;

const DislikesPill = styled(LikesPill)`
  background-color: ${WHITE};
`;

const OptionsWrap = styled.div`
  > div,
  > button {
    display: inline-block;
  }
`;

const PillOption = styled(Pill)`
  background-color: ${props =>
    props.selected ? `${ACCENT_PRIMARY_LIGHTEST}` : `${GRAY_LIGHTEST}`};
  border: none;
  color: inherit;
  font-weight: 400;
  margin: 0 10px 15px 0;
  text-transform: none;
  &:hover {
    background-color: #e6f8fe;
    border: none;
  }
`;

const Close = styled.div`
  height: 12px;
  min-height: 24px;
  min-width: 30px;
  position: absolute;
  right: 5px;
  width: 12px;
  &:hover {
    cursor: pointer;
  }
  &:after,
  &:before {
    background-color: #111;
    content: " ";
    height: 12px;
    left: 15px;
    position: absolute;
    width: 1px;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }
`;

export {
  TourLikesWrapper,
  TourLikesGroup,
  OptionsWrap,
  LikesPill,
  Close,
  Pill,
  DislikesPill,
  PillOption,
  ModalHeaderButton
};
